import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import DocumentMeta from 'react-document-meta';

const docMeta = {
  title: 'Gode råd til boligsøgningen',
  description:
    'De 5 bedste råd fra Boligninja.dk til nemt og hurtigt at finde en bolig',
  extend: true,
  auto: {
    ograph: true
  }
};

class Welcome extends Component {
  render() {
    return (
      <DocumentMeta {...docMeta}>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1 style={{ textAlign: 'center' }}>Råd til boligsøgning</h1>
              <h4 style={{ textAlign: 'center' }}>
                Hos Boligninja.dk gør vi alt, hvad vi kan, for at hjælpe dig med
                at finde en bolig. Vi har derfor samlet vores 5 bedste råd til
                din boligsøgning her:
              </h4>
              <h5 style={{ marginTop: '30px' }}>
                1. Gå i gang med boligsøgning tidligt
              </h5>
              <p>
                Selvom der er stor forskel på, hvor hård konkurrencen om
                lejeboliger er, afhængig af hvor i landet du søger, er det en
                god idé at starte din boligsøgning tidligt. Brug tiden til at
                skabe dig et overblik over lejeboligmarkedet, i den by du søger:
                hvor stort er udbuddet, hvad er prisniveauet for en bolig, der
                matcher dine behov osv.
              </p>
              <h5 style={{ marginTop: '30px' }}>2. Vær realistisk</h5>
              <p>
                Find ud af, hvor meget du har råd til at betale hver måned, og
                læg realistiske boligplaner ud fra det og ud fra, hvordan
                lejeboligmarkedet ser ud i den by, som du søger boliger i. Vi
                oplever ofte boligsøgende, der har helt urealistiske krav til en
                kommende bolig. Nogle søger eksempelvis en 3-værelses lejebolig
                i indre København til maksimum 6.000 kr. Så langt rækker 6.000
                kr. bare ikke i København - så husk at være realistisk i din
                boligsøgning.
              </p>
              <h5 style={{ marginTop: '30px' }}>3. Søg bredt</h5>
              <p>
                En bredere søgning gør oftest processen meget kortere. Der er
                selvfølgelig svært at gå på kompromis med huslejeniveauet, men
                forsøg i stedet at være fleksibel i forhold til beliggenhed,
                boligtype, størrelse og lejeperiode. Du kan eventuelt justere
                dine søgekriterier efter en tid, hvis du ikke har succes med
                dine første søgekriterier.
              </p>
              <p>
                En god tilgang til boligsøgning, særligt i storbyerne, er at
                søge i udkanten af sit ønskede område, og derefter sætte sig mål
                om at flytte længere og længere ind mod det ønskede områdes
                centrum.
              </p>
              <p>
                Det er de færreste, i hvert fald i storbyerne, der finder det
                sted, de vil bo de næste 5 år i første hug. Vær forberedt på at
                vejen til det ubegrænsede lejemål, kan være igennem en eller
                flere tidsbegrænsede lejemål.
              </p>
              <h5 style={{ marginTop: '30px' }}>
                4. Lav en god præsentation af dig selv
              </h5>
              <p>
                Hvad end du kontakter udlejer over telefon eller mail, så undgå
                standard henvendelser. Tænk over, hvordan du præsenterer dig
                selv. Udlejeren vil typisk gå op i, om du har en stabil økonomi,
                hvordan du er som nabo, og at du passer godt på boligen. Så gør
                noget ud af præsentationen af dig selv (uden at den bliver for
                lang). Husk, at det for udlejer gælder om at finde den rigtige
                lejer – og ikke den første mulige lejer.
              </p>
              <h5 style={{ marginTop: '30px' }}>
                5. Få hjælp til din boligsøgning
              </h5>
              <p>
                Hos Boligninja.dk sidder vi altid klar, både på telefon og mail,
                til at hjælpe dig med spørgsmål vedrørende din boligsøgning.
                Hvis du er interesseret, kan du maile til vores boligkonsulenter
                på mail: info (a) boligninja.dk, som gerne kigger nærmere på din
                boligsøgerannonce og dine kriterier. Boligninja’s
                boligkonsulenter giver gerne en vurdering af dine kriterier og
                eventuelle forslag til at justere dem, så du får mest ud af din
                boligsøgning hos os.
              </p>
            </Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default Welcome;
